import { ref, computed, onMounted, onUnmounted } from 'vue'

export interface DrawerWidthOptions {
  desktopWidth?: string
  mobileWidth?: string
  breakpoint?: number
}

export function useDrawerWidth(options: DrawerWidthOptions = {}) {
  const { desktopWidth = '50%', mobileWidth = '100%', breakpoint = 768 } = options

  const windowWidth = ref(window.innerWidth)

  const drawerWidth = computed(() => {
    return windowWidth.value >= breakpoint ? desktopWidth : mobileWidth
  })

  const handleResize = () => {
    windowWidth.value = window.innerWidth
  }

  onMounted(() => {
    window.addEventListener('resize', handleResize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
  })

  return {
    windowWidth: readonly(windowWidth),
    drawerWidth: readonly(drawerWidth),
    isMobile: computed(() => windowWidth.value < breakpoint),
    isDesktop: computed(() => windowWidth.value >= breakpoint),
  }
}
